import Raven from 'raven-js';
import { consoleIfNotProd } from 'chatspot-core/loggers/consoleIfNotProd';
export const LOCAL_SETTINGS_PREFIX = 'Copilot:Settings:';
const makePrefixedKey = key => {
  return LOCAL_SETTINGS_PREFIX + key;
};
export const deleteFromLocalStorage = key => {
  try {
    delete localStorage[makePrefixedKey(key)];
  } catch (error) {
    consoleIfNotProd.error('Error: deleteFrom:', error);
  }
};
export const getFromLocalStorage = key => {
  try {
    const entry = localStorage[makePrefixedKey(key)];
    if (entry === undefined) {
      return entry;
    }
    return JSON.parse(entry);
  } catch (error) {
    consoleIfNotProd.error('Error: getFrom:', error);
    Raven.captureException(error);
    return undefined;
  }
};
export const hasInLocalStorage = key => {
  try {
    return Object.prototype.hasOwnProperty.call(localStorage, makePrefixedKey(key));
  } catch (error) {
    consoleIfNotProd.error('Error: hasFrom:', error);
    Raven.captureException(error);
    return undefined;
  }
};
export const setInLocalStorage = (key, value) => {
  try {
    localStorage[makePrefixedKey(key)] = JSON.stringify(value);
    return value;
  } catch (error) {
    consoleIfNotProd.error('Error: setFrom:', error);
    Raven.captureException(error);
    return undefined;
  }
};